// TermsDialog.jsx
import CloseIcon from '@mui/icons-material/Close';
import { Dialog, DialogTitle, DialogContent, IconButton } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';

import Text from 'commons/Text';

const TermsDialog = ({ open, onClose }) => {
  const { t } = useTranslation();

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="md"
      fullWidth
    >
      <DialogTitle>
        {t('terms_and_onditions')}
        <IconButton
          onClick={onClose}
          style={{ position: 'absolute', right: 16, top: 16 }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent dividers>
        <Text
          type="sm"
          mb={16}
        >
          {t('by_validating_this_form')}
        </Text>
        <ul style={{ paddingLeft: 20, fontSize: 14 }}>
          <li style={{ marginTop: 2 }}>{t('i_acknowledge_all_my_responsibilities')}</li>
          <li style={{ marginTop: 2 }}>{t('i_acknowledge_having_been_informed')}</li>
          <li style={{ marginTop: 2 }}>{t('i_acknowledge_having_been_warned_consequences')}</li>
          <li style={{ marginTop: 2 }}>{t('i_authorize_artcertificate_display')}</li>
        </ul>

        <Text
          type="sm"
          mt={24}
          mb={8}
        >
          {t('liability_of_artcertificate')}
        </Text>
        <Text type="sm">{t('artcertificate_does_not_engage')}</Text>
      </DialogContent>
    </Dialog>
  );
};

export default TermsDialog;
